import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { EnvironmentConfig } from '@core/config-models';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { JssNavItem } from '@core/jss-models';
import { GenericLinkDirective } from '@core/jss-utils';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import { NavItemToJssRoutePipe } from './nav-item-to-jss-route.pipe';

@Component({
  selector: 'wl-navbar-item',
  templateUrl: './navbar-item.component.html',
  styleUrls: [
    './navbar-item.component.essent.scss',
    './navbar-item.component.ed.scss',
  ],
  standalone: true,
  imports: [GenericLinkDirective, CSCaptureDirective, NavItemToJssRoutePipe],
})
export class NavbarItemComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() language?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() navItem?: JssNavItem;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() type: NavBarItemType = 'nav-item';

  @Output()
  clicked = new EventEmitter<JssNavItem>();

  constructor(@Inject(ENVIRONMENT_CONFIG) readonly config: EnvironmentConfig) {}
}

type NavBarItemType = 'dropdown' | 'nav-item';
